export enum MimeEnum {
  mp3 = 'audio/mpeg',
  mp4 = 'video/mp4',
  wav = 'audio/wav',
  xWav = 'audio/x-wav',
  gif = 'image/gif',
  jpeg = 'image/jpeg',
  png = 'image/png',
  pdf = 'application/pdf',
}

export enum ImageSize {
  avatar = 75,
  thumbnailSmall = 75,
  thumbnail = 75,
  grid = 150,
  track = 250,
  artist = 250,
  user = 250,
  player = 500,
  feedCard = 500,
  controlCenter = 500,
  linkPreview = 1000,
  fullScreenPreview = 1000,
  avatarPreview = 500,
  playlistArtwork = 250,
}

export interface IImageDimensions {
  width: number;
  height: number;
}
